import { cloneDeep } from '@lsfe/tools';
import { findInTree, findPathInTree } from './utils';

export default class LevelStore {
    constructor(data, options) {
        for (let option in options) {
            if (Object.prototype.hasOwnProperty.call(options, option)) {
                this[option] = options[option];
            }
        }
        this.init(data);
    }

    // 初始化数据
    init(data) {
        // 保存一份初始data
        this.initialData = data;
        this.optData = cloneDeep(data); // 用于处理的完整数据

        this.initLevelLength(); // 计算层级数
        this.initProperty(this.optData); // 添加parentId属性
        this.activeTab = null; // 初始化，建立监听
        this.selectedValueMap = {};
        this.selectedValue = [];
        // 设置初始值
        this.setValue();
        // 初始化tab的选择
        if (this.vm.tabConfig && this.vm.tabConfig.length) {
            this.initActiveName();
            // // 如果有tab配置，用于渲染的数据需要根据tab配置进行筛选
            // this.tabsData = this.setTabsData(this.optData);
        }
        this.tabsData = this.setTabsData(this.optData);
        this.filterOptionsData = []; // 用于进行筛选的数据
        this.initOptionsData(); // 初始化用于渲染的数据
        this.initCount(); // 设置选项个数和选中个数

        // 初始化用于进行筛选的数据
        this.handleFilterOptions();
        this.vm.emitInit();
    }

    handleFilterOptions() {
        // 如果只有一层，直接使用数据
        if (this.levelLength === 1) {
            this.filterOptionsData.push({
                label: '数据',
                id: -1,
                children: this.optData
            });
            return;
        }
        this.optData.forEach(item => this.formatToFilterOptions(item, 1));
    }

    initProperty(data, parentId) {
        data.forEach(item => {
            item._parentId = parentId;
            // 设置监听属性，选中值和禁用选中值
            this.vm.$set(item, '_selectedCount', 0);
            this.vm.$set(item, '_disabledSelectedCount', 0);
            if (item.children) {
                this.initProperty(item.children, item.id);
            }
        });
    }

    initCount() {
        // 设置总个数和禁用个数
        this.setDataInfo(this.tabsData, this.levelLength, 1);
        // 设置节点的选中个数
        this.setSelectedCount();
    }

    initLevelLength() {
        let level = 0;
        let item = this.optData[0];
        while (item) {
            level += 1;
            item = item.children && item.children[0];
        }
        this.levelLength = level;
    }

    initActiveName() {
        let activeTab;
        if (!this.vm.multiple && this.vm.value && this.vm.value.length) {
            // 单选并且有值
            const selectedValue = Object.values(this.selectedValueMap || {});
            activeTab = this.vm.tabConfig.find(item => item.filter(selectedValue[0]));
        }
        if (!activeTab) {
            activeTab = this.vm.tabConfig[0];
        }
        this.setActiveTab(activeTab);
    }

    initOptionsData() {
        const selectedValue = Object.values(this.selectedValueMap || {});
        let value = selectedValue[0];
        let path = [];
        let finded = false;
        // 多选和没有value时是不用查找路径的，可以直接设置层级数据
        if (!this.vm.multiple && value) {
            finded = findPathInTree(this.tabsData, value, path, 0);
        }
        // 如果找到了值，说明是单选并且有初始值，这是应该展示选中项所在的数据列
        this.optionsData = this.formatToSelectOptions(
            this.tabsData,
            !finded,
            path.map(item => item)
        ); // 用于渲染作为选项的数据
        // 设置活跃标签
        if (path && path.length) {
            this.activeOptions = path;
        } else {
            this.activeOptions = this.optionsData.map(item => item[0]); // 当前活跃选项路径
        }
    }

    setValue() {
        if (this.vm.multiple) {
            // 多选
            this.selectedValueMap = (this.vm.value || []).reduce((prev, cur) => {
                const temp = findInTree(this.optData, cur, this.vm.valueKey) || {
                    id: cur,
                    label: cur,
                    [this.vm.valueKey]: cur
                };
                prev[temp.id] = temp;
                return prev;
            }, {});
        } else {
            // 单选
            if (this.vm.value) {
                const temp = findInTree(
                    this.optData,
                    this.vm.value,
                    this.vm.valueKey
                ) || {
                    id: this.vm.value,
                    [this.vm.valueKey]: this.vm.value,
                    label: this.vm.value
                };
                this.selectedValueMap = {
                    [temp.id]: temp
                };
            } else {
                this.selectedValueMap = {};
            }
        }
    }

    setSelectedValue() {
        this.selectedValue = Object.values(this.selectedValueMap || {}).filter(item => item);
    }

    setActiveTab(item) {
        // this.vm.$set(this, 'activeTab', item);
        this.activeTab = item;
    }

    setTabsData(data) {
        const result = [];
        data.forEach(item => {
            if (!item.children && (!this.vm.tabConfig || !this.vm.tabConfig.length || this.activeTab.filter(item))) {
                // 如果是叶子节点并且该节点符合tab的筛选条件，加入
                // 如果是叶子节点并且没有配置tabConfig，加入
                result.push(item);
            }
            if (item.children) {
                // 如果不是叶子节点，判断子节点中是否有存在的，存在，则加入
                const children = this.setTabsData(item.children);
                if (children.length) {
                    result.push({
                        ...item,
                        children
                    });
                }
            }
        });
        return result;
    }

    // 处理选择数据
    formatToSelectOptions(data, setFirst, path) {
        // 没有数据直接返回空
        if (!data || !data.length) {
            return [];
        }
        const result = [];
        // 当前层设置为传入的数据
        result[0] = data;
        // 处理后面的层级数据
        let temp;
        if (setFirst) {
            temp = data[0];
        } else {
            // 如果没有找到数据，还是设置为data[0]
            temp = path.shift() || data[0];
        }
        while (temp.children && temp.children.length) {
            result.push(temp.children);
            if (setFirst) {
                temp = temp.children[0];
            } else {
                // 如果没有找到数据，还是设置为data[0]
                temp = path.shift() || temp.children[0];
            }
        }
        return result;
    }

    // 设置筛选数据
    formatToFilterOptions(data, currentLevel, prevLabel, prevId) {
        const label = `${prevLabel ? `${prevLabel}-` : ''}${data.label}`;
        const id = `${prevId ? `${prevId}-` : ''}${data.id}`;
        if (currentLevel === this.levelLength - 1) {
            const temp = {
                label,
                id,
                children: data.children
            };
            this.filterOptionsData.push(temp);
            return;
        }
        data.children.forEach(item => this.formatToFilterOptions(item, currentLevel + 1, label, id)
        );
    }

    // 处理ViewData用于查看
    getViewData() {
        const { value } = this.getEmitValue();
        const result = [];
        const data = this.filterOptionsData;

        data.forEach(item => {
            // 如果只配置了一层，item.children没有值
            const children = (item.children || []).filter(item2 => {
                const index = value.findIndex(
                    item3 => item2[this.vm.valueKey] === item3
                );
                if (index !== -1) {
                    value.splice(index, 1);
                    return true;
                }
                return false;
            });
            if (children && children.length) {
                result.push({
                    ...item,
                    children
                });
            }
        });
        // 有剩余，说明该值不在选项中
        if (value.length) {
            result.push({
                label: '其他选中项',
                children: value.map(item => ({
                    label: item,
                    [this.vm.valueKey]: item
                }))
            });
        }
        return result;
    }

    handleFilter(keyword, maxLength = 100) {
        const result = [];
        let filterData = this.filterOptionsData;
        // 在tab下筛选
        if (!this.vm.filterInAll && this.vm.tabConfig) {
            filterData = [];
            this.filterOptionsData.forEach(item => {
                const children = item.children.filter(item => this.activeTab.filter(item));
                if (children && children.length) {
                    filterData.push({
                        ...item,
                        children
                    });
                }
            });
        }
        filterData.forEach((item, index) => {
            if(index > maxLength) {
                return;
            }
            if (item.label.includes(keyword)) {
                return result.push({
                    ...item,
                    children: (item.children || []).slice(0, maxLength) // 只展示前200条，防止数据过多性能问题
                });
            }
            const children = item.children.filter(item2 => item2.label.includes(keyword));
            if (children.length) {
                result.push({
                    ...item,
                    children: children.slice(0, maxLength) // 只展示前200条，防止数据过多性能问题
                });
            }
        });
        return result;
    }

    // 处理活跃选项
    handleChangeActiveOpt(item, level) {
        if (
            this.activeOptions.findIndex(item2 => item2.id === item.id) !== -1
        ) {
            return;
        }
        this.optionsData = this.optionsData
            .slice(0, level + 1)
            .concat(this.formatToSelectOptions(item.children, true));
        this.activeOptions[level] = item;
        this.activeOptions = this.activeOptions
            .slice(0, level + 1)
            .concat(this.optionsData.slice(level + 1).map(item => item[0]));
    }

    // 处理单选
    handleSelected(data) {
        // 禁用状态，不进行选择
        if (data.disabled) {
            return;
        }
        this.selectedValueMap = {[data.id]: data};
        if (this.vm.closePopperAfterSelected) {
            this.vm.closePopper();
        }
    }

    // 处理多选 checked标识是处理选中还是不选中，data是处理数据，deep标识是否深度处理数据，extend标识是否向上级处理
    handleCheck(checked, data, deep = true, isTop = true) {
        if (checked && !data.children) {
            // 处理选中
            this.vm.$set(this.selectedValueMap, data.id, data);
        }
        if (!checked && !data.children) {
            this.selectedValueMap[data.id] = null;
            delete this.selectedValueMap[data.id];
        }
        // 如果是中间节点，需要对子节点进行处理
        if (deep && data.children) {
            data.children.forEach(item => {
                // 如果可以选择并且是不选中或者已选中值没有该值，处理选中
                if (
                    !item.disabled &&
                    (!checked || !this.selectedValueMap[item.id])
                ) {
                    this.handleCheck(checked, item, deep, false);
                }
            });
        }
        if (isTop) {
            this.setSelectedCount();
        }
    }

    // 清空选中项
    handleClear() {
        if (!this.vm.multiple) {
            // 单选
            this.selectedValueMap = {};
        } else {
            // Object.values(this.selectedValueMap || {})
            this.selectedValue
                .filter(item => !item.disabled)
                .map(item => item)
                .forEach(item => {
                    this.handleCheck(false, item, true, false);
                });
            this.setSelectedCount();
        }
        this.vm.emitChange();
    }

    // 全选
    handleSelectAll() {
        this.optData.forEach(item => {
            this.handleCheck(true, item);
        });
        this.vm.emitChange();
    }

    // 设置数据私有属性
    setDataInfo(data, levelCount, currentLevel) {
        let sumCount = 0;
        let disabledCount = 0;
        data.forEach(item => {
            // 设置数据量
            if (currentLevel >= levelCount - 1) {
                item._count = (item.children || []).length;
                item._disabledCount = (item.children || []).filter(
                    item => item.disabled
                ).length;
                sumCount += item._count;
                disabledCount += item._disabledCount;
                return;
            }
            ({
                sumCount: item._count,
                disabledCount: item._disabledCount
            } = this.setDataInfo(item.children, levelCount, currentLevel + 1));
            sumCount += item._count;
            disabledCount += item._disabledCount;
        });
        return { sumCount, disabledCount };
    }

    // 设置选中的个数， fromZreo标识是否将父节点的数据清空重新计算
    setSelectedCount(data) {
        data = data || this.tabsData;
        const result = data.reduce((prev, item) => {
            if (!item.children && this.selectedValueMap[item.id]) {
                // 叶子节点，直接处理数据变更
                if (item.disabled) {
                    prev._disabledSelectedCount += 1;
                }
                prev._selectedCount += 1;
            }
            if (item.children) {
                const _selectedData = this.setSelectedCount(item.children);
                item._selectedCount = _selectedData._selectedCount;
                item._disabledSelectedCount = _selectedData._disabledSelectedCount;
                prev._selectedCount += _selectedData._selectedCount;
                prev._disabledSelectedCount += _selectedData._disabledSelectedCount;
            }
            return prev;
        }, {_selectedCount: 0, _disabledSelectedCount: 0});
        return result;
    }

    // 计算事件抛出的数据
    getEmitValue() {
        const { valueKey, multiple } = this.vm;
        let data = Object.values(this.selectedValueMap || {});
        let value;
        let items;
        if (multiple) {
            items = cloneDeep(data);
            value = items.map(item => item[valueKey]);
        } else {
            items = data[0] && cloneDeep(data[0]);
            value = (items && items[valueKey]) || '';
        }
        return { value, items };
    }
}
